import { isCostCenterUseEnforced } from '@frontend/cost-center/api';
import { SettingKey } from '@frontend/setting/types';
import { ScreenTrigger, ScreenType } from '@frontend/wizard/types';

import { useCostCenterSelection } from '../../hooks/useCostCenterSelection';
import { useScreen } from '../useScreen';

export const useSelectCostCenter = () => {
    const { navigationState, store, updateWizardData, onBack, onSubmit } = useScreen();
    const {
        userCostCenters,
        selectedUserCostCenter,
        isCostCenterEnabled,
        isCostCenterLoading,
        hasNoCostCenters,
        onCostCenterSelect,
        onCostCenterSearch,
        onCostCenterScrollToBottom
    } = useCostCenterSelection(navigationState.user?.auth);

    const isEnforced = isCostCenterUseEnforced(navigationState.spot?.settings?.[SettingKey.ENFORCE_COST_CENTER_USE]) && !!navigationState.user?.auth;
    const submitStep = store?.steps.find((step) => step.screen === ScreenType.SELECT_COST_CENTER && step.trigger === ScreenTrigger.SUBMIT);
    const submitDisabled = isEnforced && !selectedUserCostCenter;
    const selectedCostCenter = userCostCenters.find((costCenter) => costCenter.id === selectedUserCostCenter) ?? null;

    const handleSubmit = () => {
        if (submitDisabled) return;

        updateWizardData({
            selectedCostCenterId: selectedUserCostCenter,
            selectedCostCenterName: selectedCostCenter?.name ?? null
        });

        onSubmit(submitStep);
    };

    return {
        userCostCenters,
        selectedUserCostCenter,
        isCostCenterEnabled,
        isCostCenterLoading,
        hasNoCostCenters,
        submitDisabled,
        onCostCenterSelect,
        onCostCenterSearch,
        onCostCenterScrollToBottom,
        onBack,
        handleSubmit
    };
};
